module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/no_games_americanfootball-cbfa1fe8921a5bfe187ed4630e3a0cf3.svg";